__turbopack_context__.v({
  "className": "lexend_46c2bb5c-module__FIkqJq__className",
});
